import script from "./EstimateDisclaimer.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateDisclaimer.vue?vue&type=script&setup=true&lang=js"

import "./EstimateDisclaimer.vue?vue&type=style&index=0&id=19817e6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19817e6a"]])

export default __exports__